import { reloadConfig } from "./reloadConfig";
import { useQuery } from "@tanstack/react-query";
import configuration from "utils/config";

/**
 * Client hook to reload the configuration file.
 * @returns The string version of the configuration file.
 */
export function useVersionReload() {
    return useQuery({
        queryKey: ["versionReload"],
        queryFn: async () => {
            await reloadConfig();

            return { version: window.__runtime_configuration.version };
        },
        refetchInterval: 10 * 60 * 1000,
        staleTime: 10 * 60 * 1000,
        refetchOnWindowFocus: true,
        initialData: { version: configuration.version },
        refetchOnMount: false,
    });
}
